import { render } from "./accept-invite.vue?vue&type=template&id=21da8544&scoped=true"
import script from "./accept-invite.vue?vue&type=script&lang=js"
export * from "./accept-invite.vue?vue&type=script&lang=js"

import "./accept-invite.vue?vue&type=style&index=0&id=21da8544&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21da8544"]])

export default __exports__